import type { DecoderKind } from './types';

const EXT_MAP: Record<string, DecoderKind> = {
  png: 'image', jpg: 'image', jpeg: 'image', webp: 'image', avif: 'image', bmp: 'image',
  gif: 'gif',
  svg: 'svg',
  heic: 'heic', heif: 'heic',
  pdf: 'pdf',
};

const MIME_MAP: Record<string, DecoderKind> = {
  'image/png': 'image',
  'image/jpeg': 'image',
  'image/webp': 'image',
  'image/avif': 'image',
  'image/bmp': 'image',
  'image/gif': 'gif',
  'image/svg+xml': 'svg',
  'image/heic': 'heic',
  'image/heif': 'heic',
  'application/pdf': 'pdf',
};

export function detectFormat(file: File): DecoderKind | null {
  const m = MIME_MAP[file.type.toLowerCase()];
  if (m) return m;
  const ext = file.name.split('.').pop()?.toLowerCase() ?? '';
  return EXT_MAP[ext] ?? null;
}

export function isSupported(file: File): boolean {
  return detectFormat(file) !== null;
}
